import React from 'react';
import './Chip.scss';
import Cancel from '../../../../assets/icons/Cancel';

const Chip = ({text, deleteOnClick, status}) => {
    return (
        <div className= {`v2-chip  chip-${status}`}>
            <p className={`subtitle-3 ${status ? 'v2-c-' + status : 'v2-c-primary-500'}`}>{text}</p>
            {deleteOnClick && <div className={'v2-chip-cancel-container'} onClick={deleteOnClick}><Cancel width={'10px'} height={'10px'}/></div> }
        </div>
    );
};

export default Chip;
